module.exports = __webpack_public_path__ + "img/4.a06a8c24.jpg";